<div class="h-100 w-100 position-relative" id="preview-section">
  <!-- Scene Container -->
  <div #threeContainer id="three-preview-container" class="h-100 w-100" (contextmenu)="$event.preventDefault()"></div>

  <!-- Preview Title -->
  <div class="preview-title">
    Aperçu de vos plans de travail
  </div>

  <!-- UI Overlay (Buttons for rotation, etc.) -->
  <!-- When snapshotting: only active edge_band buttons are visible -->
  <ng-container *ngFor="let button of actionButtons; trackBy: trackById">
    <div *ngIf="(!isSnapshotting && !isSummary) || button.isActive"
      class="position-absolute d-flex justify-content-center align-items-center rounded-circle shadow-sm"
      [ngClass]="{
        'bg-white': !button.isActive,
        'bg-primary text-white': button.isActive && button.icon !== 'cut-straight' && button.icon !== 'cut-rounded',
        'cutaway-btn-straight text-white': button.isActive && button.icon === 'cut-straight',
        'cutaway-btn-round text-white': button.isActive && button.icon === 'cut-rounded'
      }" [style.left.px]="button.x"
      [style.top.px]="button.y"
      [style.pointer-events]="isSummary ? 'none' : 'auto'"
      style="width: 30px; height: 30px; cursor: pointer; transform: translate(-50%, -50%); z-index: 10;"
      (click)="$event.stopPropagation(); onActionButtonClick(button)" (mousedown)="$event.stopPropagation()"
      (pointerdown)="$event.stopPropagation()" [title]="button.tooltip">

      <ng-container *ngIf="button.icon === 'rotate-left'">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <polyline points="1 4 1 10 7 10"></polyline>
          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
        </svg>
      </ng-container>

      <ng-container *ngIf="button.icon === 'edge_band'">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" style="pointer-events: none;">
          <!-- Arrow pointing to edge -->
          <line x1="5" y1="12" x2="13" y2="12"></line>
          <polyline points="10 9 13 12 10 15"></polyline>
          <!-- Edge element -->
          <rect x="16" y="5" width="4" height="14" rx="1"></rect>
        </svg>
      </ng-container>

      <ng-container *ngIf="button.icon === 'arrow-down'">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <polyline points="19 12 12 19 5 12"></polyline>
        </svg>
      </ng-container>

      <ng-container *ngIf="button.icon === 'cut'">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <circle cx="6" cy="6" r="3"></circle>
          <circle cx="6" cy="18" r="3"></circle>
          <line x1="20" y1="4" x2="8.12" y2="15.88"></line>
          <line x1="14.47" y1="14.48" x2="20" y2="20"></line>
          <line x1="8.12" y1="8.12" x2="12" y2="12"></line>
        </svg>
      </ng-container>

      <ng-container *ngIf="button.icon === 'cut-straight'">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round">
          <!-- Square with chamfered corner (triangle cut) -->
          <path d="M 3 21 L 21 21 L 21 3 L 13 3 L 3 13 Z" stroke="currentColor" fill="none" />
          <path d="M 13 3 L 3 13" stroke="currentColor" stroke-width="2.5" />
        </svg>
      </ng-container>

      <ng-container *ngIf="button.icon === 'cut-rounded'">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round">
          <!-- Square with rounded corner (fillet) -->
          <path d="M 3 21 L 21 21 L 21 3 L 13 3 A 10 10 0 0 0 3 13 Z" stroke="currentColor" fill="none" />
          <path d="M 13 3 A 10 10 0 0 0 3 13" stroke="currentColor" stroke-width="2.5" />
        </svg>
      </ng-container>

      <ng-container *ngIf="button.icon === 'rotate-right'">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <polyline points="23 4 23 10 17 10"></polyline>
          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
        </svg>
      </ng-container>

      <ng-container *ngIf="button.icon === 'wall'">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="3" y1="9" x2="21" y2="9"></line>
          <line x1="3" y1="15" x2="21" y2="15"></line>
          <line x1="9" y1="9" x2="9" y2="15"></line>
          <line x1="15" y1="15" x2="15" y2="21"></line>
          <line x1="15" y1="3" x2="15" y2="9"></line>
        </svg>
      </ng-container>

    </div>
  </ng-container>

  <!-- Cutaway Menu Context (Action Wheel) -->
  <div *ngIf="cutawayMenu" class="position-absolute" [style.left.px]="cutawayMenu.x" [style.top.px]="cutawayMenu.y"
    style="z-index: 1001; width: 0; height: 0; overflow: visible;" (pointerdown)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()">

    <!-- Straight Cut -->
    <!-- Straight Cut (Top-Left) -->
    <div class="position-absolute d-flex flex-column align-items-center"
      style="transform: translate(-70px, -60px); cursor: pointer;"
      (click)="$event.stopPropagation(); applyCutaway('straight')">
      <div class="btn btn-white rounded-circle d-flex align-items-center justify-content-center shadow"
        style="width: 48px; height: 48px; background: white; border: 2px solid #ddd;">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="20" y1="4" x2="4" y2="20"></line>
        </svg>
      </div>
      <small
        style="font-size: 10px; font-weight: bold; background: rgba(255,255,255,0.8); padding: 0 4px; border-radius: 4px; margin-top: 4px;">Droite</small>
    </div>

    <!-- Rounded Cut -->
    <!-- Rounded Cut (Top-Right) -->
    <div class="position-absolute d-flex flex-column align-items-center"
      style="transform: translate(22px, -60px); cursor: pointer;"
      (click)="$event.stopPropagation(); applyCutaway('rounded')">
      <div class="btn btn-white rounded-circle d-flex align-items-center justify-content-center shadow"
        style="width: 48px; height: 48px; background: white; border: 2px solid #ddd;">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 4a16 16 0 0 0-16 16"></path>
        </svg>
      </div>
      <small
        style="font-size: 10px; font-weight: bold; background: rgba(255,255,255,0.8); padding: 0 4px; border-radius: 4px; margin-top: 4px;">Arrondie</small>
    </div>

    <!-- Remove -->
    <!-- Remove (Bottom-Center) - Only if exists -->
    <div *ngIf="cutawayMenu.existingIdx !== -1" class="position-absolute d-flex flex-column align-items-center"
      style="transform: translate(-24px, 12px); cursor: pointer;"
      (click)="$event.stopPropagation(); applyCutaway('remove')">
      <div class="btn btn-white rounded-circle d-flex align-items-center justify-content-center shadow"
        style="width: 48px; height: 48px; background: white; border: 2px solid #dc3545; color: #dc3545;">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
      <small
        style="font-size: 10px; font-weight: bold; background: rgba(255,255,255,0.8); padding: 0 4px; border-radius: 4px; margin-top: 4px; color: #dc3545;">Aucun</small>
    </div>

  </div>

  <!-- Dimensions Overlay -->
  <div *ngFor="let dim of dimensions; trackBy: trackById"
    class="position-absolute d-flex align-items-center justify-content-center" [style.left.px]="dim.x"
    [style.top.px]="dim.y" [style.transform]="'translate(-50%, -50%) rotate(' + dim.angle + 'deg)'"
    style="z-index: 1000; pointer-events: none;">

    <!-- Dimension Line (Absolute) -->
    <div *ngIf="dim.length" class="position-absolute d-flex align-items-center justify-content-between"
      [style.width.px]="dim.length" style="z-index: 1;">
      <!-- Left Tick/Dot -->
      <div style="width: 1px; height: 6px; background-color: #333;"></div>
      <!-- Main Line -->
      <div class="flex-grow-1" style="height: 1px; background-color: #777;"></div>
      <!-- Right Tick/Dot -->
      <div style="width: 1px; height: 6px; background-color: #333;"></div>
    </div>

    <!-- Label (On Top) -->
    <div class="position-relative" style="z-index: 2; pointer-events: auto;">
      <!-- Edit Mode -->
      <div *ngIf="editingDimension?.id === dim.id"
        class="d-flex align-items-center bg-white border border-primary shadow-sm rounded"
        style="padding: 0 4px; box-shadow: 0 0 5px rgba(0,123,255,0.5) !important;">
        <input type="number" [(ngModel)]="editValue" (blur)="onDimensionSubmit()" (keydown.enter)="onDimensionSubmit()"
          (keydown.escape)="onDimensionCancel()" (pointerdown)="$event.stopPropagation()"
          class="border-0 p-0 m-0 text-center" autofocus
          style="width: 50px; font-size: 12px; height: 20px; outline: none; background: transparent;">
        <span style="font-size: 12px; color: #333; margin-left: 2px;">mm</span>
      </div>

      <!-- Display Mode -->
      <div *ngIf="editingDimension?.id !== dim.id" (click)="onDimensionClick(dim)"
        (pointerdown)="$event.stopPropagation()" class="px-1 rounded shadow-sm border" [ngClass]="{
          'bg-white': !dim.isCalculated && !dim.isReadOnly,
          'border-primary': dim.planId,
          'border-0': dim.isReadOnly,
          'fw-bold': dim.isReadOnly
        }"
        [style.background-color]="dim.isReadOnly ? 'rgba(248, 249, 250, 0.9)' : (dim.isCalculated ? '#e9ecef' : 'white')"
        [style.cursor]="(dim.planId && !dim.isReadOnly) ? 'pointer' : 'default'"
        [style.color]="dim.isReadOnly ? '#212529' : '#333'" style="font-size: 12px; white-space: nowrap;">
        <ng-container *ngIf="dim.prefix">{{ dim.prefix }} </ng-container>{{ dim.value }} mm
      </div>
    </div>
  </div>

  <!-- Magnetism Icon (//) -->
  <div *ngFor="let mag of magnetismIcons"
    class="position-absolute d-flex justify-content-center align-items-center bg-dark text-white rounded-circle"
    [style.left.px]="mag.x" [style.top.px]="mag.y"
    style="width: 24px; height: 24px; transform: translate(-50%, -50%); z-index: 8; pointer-events: none; font-size: 10px;">
    //
  </div>

  <!-- Plan ID Indicators (Top-Most) -->
  <div *ngFor="let indicator of planIndicators"
    class="position-absolute d-flex justify-content-center align-items-center border border-secondary rounded-pill shadow-sm px-2"
    [style.left.px]="indicator.x" [style.top.px]="indicator.y"
    style="min-width: 28px; height: 28px; transform: translate(-50%, -50%); background-color: #e0e0e0; color: #000; z-index: 100; font-weight: bold; pointer-events: none; opacity: 0.9; white-space: nowrap;">
    {{ indicator.label }}
  </div>

  <!-- Splashback Indicators -->
  <div *ngFor="let indicator of splashbackIndicators"
    class="position-absolute d-flex justify-content-center align-items-center border border-secondary rounded-pill shadow-sm px-2"
    [style.left.px]="indicator.x" [style.top.px]="indicator.y"
    style="min-width: 28px; height: 28px; transform: translate(-50%, -50%); background-color: #e0e0e0; color: #000; z-index: 100; font-weight: bold; pointer-events: none; opacity: 0.9; white-space: nowrap;">
    {{ indicator.label }}
  </div>

  <!-- 2D Legend -->
  <div #legendEl *ngIf="showLegend" class="preview-legend position-absolute bg-white shadow-sm p-4 rounded"
    style="top: 50px; left: 20px; z-index: 10; font-size: 1.1rem; pointer-events: none; min-width: 220px;">

    <div class="d-flex flex-column gap-2">

      <!-- ── Indicateurs visuels ─────────────────────────────────────── -->
      <ng-container *ngIf="legendHasEdgeBand || legendHasSideCutBand || legendHasJamb ||
                           legendHasStraightCutaway || legendHasRoundedCutaway ||
                           legendHasPlanCutting || legendHasSplashbackCutting || legendHasSplashback">
        <div class="legend-section-title">Légende</div>
      </ng-container>

      <!-- Bande de chant (non-Quartz) -->
      <div *ngIf="legendHasEdgeBand" class="d-flex align-items-center gap-3" style="font-size: 0.9rem">
        <div class="d-flex align-items-center gap-1" style="flex-shrink:0">
          <div style="width:24px; height:6px; background:#4da6ff; border-radius:2px;"></div>
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#555" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="13" y2="12"></line><polyline points="10 9 13 12 10 15"></polyline>
            <rect x="16" y="5" width="4" height="14" rx="1"></rect>
          </svg>
        </div>
        <span class="fw-medium">Bande de chant</span>
      </div>

      <!-- Bord droit poli (Quartz) -->
      <div *ngIf="legendHasSideCutBand" class="d-flex align-items-center gap-3" style="font-size: 0.9rem">
        <div class="d-flex align-items-center gap-1" style="flex-shrink:0">
          <div style="width:24px; height:6px; background:#4da6ff; border-radius:2px;"></div>
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#555" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="13" y2="12"></line><polyline points="10 9 13 12 10 15"></polyline>
            <rect x="16" y="5" width="4" height="14" rx="1"></rect>
          </svg>
        </div>
        <span class="fw-medium">Bord droit poli</span>
      </div>

      <!-- Jambage -->
      <div *ngIf="legendHasJamb" class="d-flex align-items-center gap-3" style="font-size: 0.9rem">
        <div class="d-flex align-items-center gap-1" style="flex-shrink:0">
          <svg width="24" height="20" style="border-radius:2px; flex-shrink:0">
            <defs>
              <pattern id="hatchJamb" patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(45)">
                <rect width="6" height="6" fill="transparent" />
                <line x1="0" y1="0" x2="0" y2="6" stroke="#ffa500" stroke-width="2" />
              </pattern>
            </defs>
            <rect width="24" height="20" fill="url(#hatchJamb)" stroke="#ffa500" stroke-width="1" />
          </svg>
          <!-- Jamb icon: thin strip alongside plan -->
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <polyline points="19 12 12 19 5 12"></polyline>
          </svg>
        </div>
        <span class="fw-medium">Jambage</span>
      </div>

      <!-- Découpe droite d'angle -->
      <div *ngIf="legendHasStraightCutaway" class="d-flex align-items-center gap-3" style="font-size: 0.9rem">
        <div class="d-flex align-items-center gap-1" style="flex-shrink:0">
          <svg width="20" height="20">
            <path d="M 0,16 L 16,16 L 16,0 Z" fill="rgba(255,0,0,0.4)" stroke="#ff0000" stroke-width="1"
              stroke-dasharray="2,2" />
          </svg>
          <div class="d-flex align-items-center justify-content-center rounded-circle shadow-sm"
            style="width: 25px; height: 25px; background-color: #8731a3;">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="white" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M 3 21 L 21 21 L 21 3 L 13 3 L 3 13 Z" />
              <path d="M 13 3 L 3 13" stroke-width="2.5" />
            </svg>
          </div>
        </div>
        <span>Découpe d'angle droite</span>
      </div>

      <!-- Découpe arrondie d'angle -->
      <div *ngIf="legendHasRoundedCutaway" class="d-flex align-items-center gap-3" style="font-size: 0.9rem">
        <div class="d-flex align-items-center gap-1" style="flex-shrink:0">
          <svg width="20" height="20">
            <path d="M 0,16 A 16,16 0 0,0 16,0 L 16,16 Z" fill="rgba(255,0,0,0.4)" stroke="#ff0000" stroke-width="1"
              stroke-dasharray="2,2" />
          </svg>
          <div class="d-flex align-items-center justify-content-center rounded-circle shadow-sm"
            style="width: 25px; height: 25px; background-color: #78a321;">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="white" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M 3 21 L 21 21 L 21 3 L 13 3 A 10 10 0 0 0 3 13 Z" />
              <path d="M 13 3 A 10 10 0 0 0 3 13" stroke-width="2.5" />
            </svg>
          </div>
        </div>
        <span>Découpe d'angle arrondie</span>
      </div>

      <!-- Ouverture de plan -->
      <div *ngIf="legendHasPlanCutting" class="d-flex align-items-center gap-3" style="font-size: 0.9rem">
        <div class="d-flex align-items-center gap-1" style="flex-shrink:0">
          <svg width="24" height="20" style="border-radius:2px;">
            <defs>
              <pattern id="hatchPlanCutting" patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(-45)">
                <rect width="6" height="6" fill="transparent" />
                <line x1="0" y1="0" x2="0" y2="6" stroke="#dd4400" stroke-width="2" />
              </pattern>
            </defs>
            <rect width="24" height="20" fill="url(#hatchPlanCutting)" stroke="#dd4400" stroke-width="1" />
          </svg>
        </div>
        <span class="fw-medium">Ouverture de plan</span>
      </div>

      <!-- Ouverture de crédence -->
      <div *ngIf="legendHasSplashbackCutting" class="d-flex align-items-center gap-3" style="font-size: 0.9rem">
        <div class="d-flex align-items-center gap-1" style="flex-shrink:0">
          <svg width="24" height="20" style="border-radius:2px;">
            <defs>
              <pattern id="hatchSbCutting" patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(-45)">
                <rect width="6" height="6" fill="transparent" />
                <line x1="0" y1="0" x2="0" y2="6" stroke="#dd4400" stroke-width="2" />
              </pattern>
            </defs>
            <rect width="24" height="20" fill="url(#hatchSbCutting)" stroke="#dd4400" stroke-width="1" />
          </svg>
        </div>
        <span class="fw-medium">Ouverture de crédence</span>
      </div>

      <!-- Crédence -->
      <div *ngIf="legendHasSplashback" class="d-flex align-items-center gap-3" style="font-size: 0.9rem">
        <div class="d-flex align-items-center gap-1" style="flex-shrink:0">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#555" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="3" y1="9" x2="21" y2="9"></line><line x1="3" y1="15" x2="21" y2="15"></line>
            <line x1="9" y1="9" x2="9" y2="15"></line><line x1="15" y1="15" x2="15" y2="21"></line>
            <line x1="15" y1="3" x2="15" y2="9"></line>
          </svg>
        </div>
        <span class="fw-medium">Crédence</span>
      </div>

    </div>
  </div>

  <!-- Preview Toolbar -->
  <!--<div class="preview-toolbar" *ngIf="!isSnapshotting">
    <-- 3D Toggle --
    <button class="btn-icon" (click)="enable3DMode()" *ngIf="!is3DMode" title="Vue 3D">
      3D
    </button>
    <button class="btn-icon active" (click)="disable3DMode()" *ngIf="is3DMode" title="Retour 2D">
      2D
    </button>

    <div class="divider"></div>

    <-- Snapshot --
    <button class="btn-icon" (click)="downloadSnapshot()" title="Télécharger Image">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
        <circle cx="12" cy="13" r="4"></circle>
      </svg>
    </button>
  </div>-->
</div>